export enum ReportDataTypes {
    PERCENTAGE = "percentage",
}
